/**
 * @typedef {'xs' | 'sm' | 'md' | 'lg' | 'xlg' | 'xxlg'} BaoMediaBreakpoint
 */

window.BAO.MediaBreakpoints = class MediaBreakpoints {
  static get breakpoints () {
    return {
      xs: 450,
      sm: 768,
      md: 900,
      lg: 1200,
      xlg: 1440,
      xxlg: 1600,
    }
  }

  static get isXxs () {
    return this.windowWidth > this.breakpoints.xs
  }

  static get isXs () {
    return this.windowWidth > this.breakpoints.xs
  }

  static get isSm () {
    return this.windowWidth >= this.breakpoints.sm
  }

  static get isMd () {
    return this.windowWidth > this.breakpoints.md
  }

  static get isLg () {
    return this.windowWidth > this.breakpoints.lg
  }

  static get isXlg () {
    return this.windowWidth > this.breakpoints.xlg
  }

  static get isXxlg () {
    return this.windowWidth > this.breakpoints.xxlg
  }

  static get isXxsViewport () {
    return this.windowWidth <= this.breakpoints.xs
  }

  static get isXsViewport () {
    return this.windowWidth < this.breakpoints.sm
  }

  static get isSmViewport () {
    return (
      this.breakpoints.sm <= this.windowWidth &&
      this.windowWidth <= this.breakpoints.md
    )
  }

  static get isMdViewport () {
    return (
      this.breakpoints.md < this.windowWidth &&
      this.windowWidth <= this.breakpoints.lg
    )
  }

  static get isLgViewport () {
    return (
      this.breakpoints.lg < this.windowWidth &&
      this.windowWidth <= this.breakpoints.xlg
    )
  }

  static get windowWidth () {
    return window.visualViewport.width
  }
}
